import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Select, TextInput } from 'advenio-components'
import styled from 'styled-components'
import OriginalIsland from '../../Components/Island/Island'
import ConsuimblesCategoryDetails from '../../Containers/AddContract/ConsuimblesCategoryDetails'


const Island = styled(OriginalIsland).attrs({
  paddedBody: true,
  headingFontSize: 16,
})`
    margin-bottom: 24px;
    box-shadow: 0 4px 16px rgba(0,0,0, .15);
    ${({ service }) => service && `
      margin-top: 2%;
      margin-bottom: 9%;
      `}
`
const SelectContainer = styled.div`
  width: 38%;
  display:inline-block;
  ${({ product }) => product && `
   margin-bottom: 0px;
   width:49%;
   margin-right:18px;
  `}
`
const InputContainer = styled.div`
  margin-bottom: 15px;
  ${({ datePicker }) => datePicker && `
    flex: 2;
    margin: 0 0 0px 8px;
    width:30%;
    display:inline-block;
  `}
  ${({ name }) => name && `
    margin-bottom: 0px;
  `}
  ${({ student_limit }) => student_limit && `
    width:49%;
    display:inline-block;
  `}
  ${({ prices_totals }) => prices_totals && `
    width:194px;
    margin: -10px 3px;
    display:inline-block;
  `}
  ${({ service }) => service && `
    width: 49%;
    margin: -10px 7px -10px 3px;
    display:inline-block;
    .hidden-input{
      display:none;
    }
  `}
  ${({ hidden }) => hidden && `
    display:none;
  `}
`
const ButtonContainer = styled.div`
	width: 19%;
	content: counters;
	margin-left: 72%;
	display: flex;
	margin-top: 0%;
	margin-bottom: 0%;
`
class ServiceDetails extends Component {
  state = {
    isWithSupport: false,
  }

  componentWillMount() {
    const { match: { path } } = this.props
    const isWithSupport = path.includes('with-support')
    this.setState({ isWithSupport })
  }
  render() {
    const { product, category, studentsLimit, index, products, addExtra, deleteExtra, deleteService, changeService, handledChange, studentsTotals } = this.props
    const indexProduct = index
    const { isWithSupport } = this.state
    // console.log(studentsTotals);
    return (
      <Island index={index} service heading={`Servicio ${index + 1}`} button={studentsTotals === 0 ? (e) => { deleteService(index) } : false} >
        {product.country_product_id > 0 ?
          <InputContainer service>
            <TextInput
              type="text"
              name={`products[${index}].product_name`}
              label="Tipo de Servicio"
              value={product.product_name}
              disabled
            />
            <div className="hidden-input">
              <TextInput
                type="hidden"
                name={`products[${index}].country_product_id`}
                value={product.country_product_id}
              />
            </div>
          </InputContainer>
          :
          <SelectContainer product>
            <Select
              required
              name={`products[${index}].country_product_id`}
              label="Tipo de Servicio"
              options={products}
              value={product.country_product_id ? product.country_product_id : null}
              placeholder="Selecciona a un servicio"
              onChangeCallback={(e) => { changeService(e) }}
              disabled={studentsTotals > 0}
            />
          </SelectContainer>
        }
        <InputContainer hidden>
          <div>
            <TextInput
              type="hidden"
              name={`products[${index}].students_totals`}
              value={studentsTotals}
            />
          </div>
        </InputContainer>
        <InputContainer student_limit>
          <TextInput
            type="text"
            name={`products[${index}].students_limit`}
            label="¿Cuál es el limite de niños que se pueden inscribir en el centro?"
            help="Dejar el campo en blanco si no hay limite"
            value={product.students_limit === null ? studentsLimit : product.students_limit}
            validations="isInt"
            validationErrors={{ isInt: 'El limite debe ser un número entero' }}
          />
        </InputContainer>
        <InputContainer prices_totals>
          <TextInput
            type="text"
            name={`products[${index}].monthly_total`}
            label="Mensualidad"
            value={product.monthly_total === 0 ? 0 : product.monthly_total}
            validations="isNumeric"
            validationErrors={{ isNumeric: 'Debe ser un númerico' }}
          />
        </InputContainer>
        <InputContainer prices_totals>
          <TextInput
            type="text"
            name={`products[${index}].enrollment_total`}
            label="Inscripción"
            value={product.enrollment_total === 0 ? 0 : product.enrollment_total}
            validations="isNumeric"
            validationErrors={{ isNumeric: 'Debe ser un númerico' }}
          />
        </InputContainer>
        <InputContainer prices_totals>
          <TextInput
            type="text"
            name={`products[${index}].reenrollment_total`}
            label="Reinscripción"
            value={product.reenrollment_total === 0 ? 0 : product.reenrollment_total}
            validations="isNumeric"
            validationErrors={{ isNumeric: 'Debe ser un númerico' }}
          />
        </InputContainer>
        <InputContainer prices_totals>
          <TextInput
            type="text"
            name={`products[${index}].materials_total`}
            label="Costo Materiales"
            value={product.materials_total === 0 ? 0 : product.materials_total}
            validations="isNumeric"
            validationErrors={{ isNumeric: 'Debe ser un númerico' }}
          />
        </InputContainer>
        {isWithSupport && (
          <div>
            <InputContainer prices_totals>
              <TextInput
                type="text"
                name={`products[${index}].monthly_support`}
                label="Mensualidad Compañia"
                value={product.monthly_support === 0 ? 0 : product.monthly_support}
                validations="isNumeric"
                validationErrors={{ isNumeric: 'Debe ser un númerico' }}
              />
            </InputContainer>
            <InputContainer prices_totals>
              <TextInput
                type="text"
                name={`products[${index}].enrollment_support`}
                label="Inscripción Compañia"
                value={product.enrollment_support === 0 ? 0 : product.enrollment_support}
                validations="isNumeric"
                validationErrors={{ isNumeric: 'Debe ser un númerico' }}
              />
            </InputContainer>
            <InputContainer prices_totals>
              <TextInput
                type="text"
                name={`products[${index}].reenrollment_support`}
                label="Reinscripción Compañia"
                value={product.reenrollment_support === 0 ? 0 : product.reenrollment_support}
                validations="isNumeric"
                validationErrors={{ isNumeric: 'Debe ser un númerico' }}
              />
            </InputContainer>
            <InputContainer prices_totals>
              <TextInput
                type="text"
                name={`products[${index}].materials_support`}
                label="Costo Materiales Compañia"
                value={product.materials_support === 0 ? 0 : product.materials_support}
                validations="isNumeric"
                validationErrors={{ isNumeric: 'Debe ser un númerico' }}
              />
            </InputContainer>
          </div>
        )}
        {isWithSupport && product.extra_support.length > 0 && (product.extra_support.map((extra, index) => (
          <ConsuimblesCategoryDetails
            key={`products[${indexProduct}].extra_support[${extra.consumable_type_id}]`}
            product={product}
            indexProduct={indexProduct}
            category={category}
            index={index}
            extra={extra}
            deleteExtra={deleteExtra}
            handledChange={handledChange}
          />
        )))}
        {isWithSupport &&
          (<ButtonContainer>
            <Button primary small onClick={(e) => { addExtra(index) }} >Agregar Extra</Button>
          </ButtonContainer>)
        }
      </Island>
    )
  }
}
const mapStateToProps = state => ({
  countries: state.countries.get.results,
})

const mapDispatchToProps = dispatch => ({
})
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ServiceDetails))



// WEBPACK FOOTER //
// ./src/Containers/AddContract/ServiceDetails.jsx